import { render, staticRenderFns } from "./WarmWater.vue?vue&type=template&id=f35573e0&scoped=true&"
import script from "./WarmWater.vue?vue&type=script&lang=ts&"
export * from "./WarmWater.vue?vue&type=script&lang=ts&"
import style0 from "./WarmWater.vue?vue&type=style&index=0&id=f35573e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35573e0",
  null
  
)

export default component.exports